import {
  AppBar,
  Button,
  Dialog,
  IconButton,
  Paper,
  Toolbar,
  Typography,
  Box,
  TextField,
} from "@material-ui/core";
import React from "react";
import PageHeader from "../../common/PageHeader";
import {
  apiBatchRequest,
  apiDelete,
  apiPost,
  apiPut,
  apiRequest,
  apiRequestNoLoadder,
} from "../../../utils/api_service";
import BackspaceIcon from "@material-ui/icons/BackspaceRounded";
import {
  isInputValid,
  IsSectionVisible,
  UpdateFieldsWithConfiguration,
} from "../../../utils/helper";
import FormGenerator from "../../common/FormGenerator";
import { API_URL, getCurrentEnvironment } from "../../../constants/api";
import { controlType } from "../../../constants/common";
import camelcaseKeys from "camelcase-keys";
import AutoSearch from "../../common/AutoSearch/AutoSearch";
import SimpleSelect from "../../common/AutoSearch/SimpleSelect";
import { ShowToast, toastType } from "../../../utils/toast-service";
import commonLabels from "../../../constants/messageConstants";
import ConfirmDialog from "../../common/Dailogbox/confirmDailog";
import { IoMdCloseCircleOutline } from "react-icons/io";
import moment from "moment";
import ViewHistoryData from "../../common/ViewHistoryData/ViewHistoryData";
import Autocomplete from "@material-ui/lab/Autocomplete";
import EditBuilding from "../Building/EditBuilding";
import EditLand from "../Land/EditLand";
import EditBuildingOwner from "../BuildingOwner/EditIndBuildingOwners";
import { SECTIONS } from "../../../constants/appConstants";
import { Redirect, withRouter } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { getSharePointUrl } from "../../../constants/sharepointApi";
import { getSPSTokenData, setSPSToken } from "../../../constants/constants";
import { getSpsAPiRequest } from "../../../utils/api_service";

class EditIOSSalesComp extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedMarketId: this.props.globalMarketId,
      getSalesCompDetails: [],
      getSalesCompDetailsResponse: [],
      buildingMasterDetails: props.buildingMasterDetails || [],
      salesCompFormData: [],
      lastModifiedValue: "",
      isEditEnabled: this.props.isInAddMode,
      openDialog: true,
      getAllMSalesStatus: props.getAllMSalesStatus || [],
      getAllBuyerDetails: [],
      getAllSellerDetails: [],
      brokerMasterDetails:
        props.brokerMasterDetails != undefined ? props.brokerMasterDetails : [],
      getBrokerMaster: [],
      getAllCompType: [],
      salesCompsSummaryData: [],
      isDataSaved: false,
      isSearchedClicked: false,
      showConfirmDialog: false,
      compId: props.selectedCompId,
      getHistoryDetailByField: [],
      openHistoryform: false,
      isHistoryByField: false,
      getHistory: [],
      detailView: false,
      selectedEditRowId: -1,
      ViewTitle: "Add",
      actionType: "Add",
      isRedirectedFromTenant: false,
      selectedBuildingOwner: undefined,
      selectedSeller: undefined,
      reloadCompanyPopup: false,
      selectedBuilding: undefined,
      selectedLand: undefined,
      reloadCompData: false,
      downloadURL: null,
      spListkey: props.spListkey || null,
      getAllRepresentationType: [],
      getAllTenancy: [],
      getAllNegotationType: [],
      getAllCompSource: [],
      clearText: "Clear All",
      undoText: "Undo",
      buyerSelected: null,
      sellerSelected: null,
      isAddedFromPopup: false,
      isDeleteClicked: false,
      buildingNameSelected: null,
      landNameSelected: null,
      getAllInvestmentType: [],
      getAllDockHeight: [],
      getAllDockConfiguration: [],
      selectedBuildingDetails: props.getBuildingDetails,
      getSubMarketMaster: this.props.getSubMarketMaster,
      getMarketMaster: this.props.getMarketMaster,
      getAllIndLand: [],
      getCraneMaster: props.getCraneMaster != undefined ? props.getCraneMaster : [],
      iosCompType: "Property",
      tempPropertyValue: null,
      tempPropertyId: null,
      tempLandValue: null,
      tempLandId: null,
      notFound: false,
      unAuthorized: false
    };
  }

  getFieldValue = (fields, dbColumn) =>
    ((fields || []).find((x) => x.dbColumn == dbColumn) || {}).attributeValue;

  setFieldValue = (fields, dbColumn, value) => {
    const field = (fields || []).find((x) => x.dbColumn == dbColumn);
    if (field) {
      field.attributeValue = value;
    }
  };

  setFieldEditable = (fields, dbColumn, isEditable) => {
    const field = (fields || []).find((x) => x.dbColumn == dbColumn);
    if (field) {
      field.isEditable = isEditable;
    }
  };

  setFieldRequired = (fields, dbColumn, isRequired) => {
    const field = (fields || []).find((x) => x.dbColumn == dbColumn);
    if (field) {
      field.isRequired = isRequired;
    }
  };

  getInitialIOSCompType = (fields) => {
    const landName = this.getFieldValue(fields, "PropertyName");
    return landName == null || landName === "" ? "Property" : "Land";
  };

  applyIOSCompTypeToFields = (fields, iosCompType) => {
    this.setFieldValue(fields, "IOSCompType", iosCompType);
    this.setFieldEditable(fields, "BuildingName", iosCompType === "Property");
    this.setFieldEditable(fields, "PropertyName", iosCompType === "Land");
    this.setFieldRequired(fields, "BuildingName", iosCompType === "Property");
    this.setFieldRequired(fields, "PropertyName", iosCompType === "Land");
    return fields;
  };

  getIOSCompTypeStateFromFields = (fields) => ({
    iosCompType: this.getFieldValue(fields, "IOSCompType") || "Property",
    tempPropertyValue: this.getFieldValue(fields, "BuildingName") || null,
    tempPropertyId: this.getFieldValue(fields, "BuildingId") || null,
    tempLandValue: this.getFieldValue(fields, "PropertyName") || null,
    tempLandId: this.getFieldValue(fields, "LandId") || null,
  });

  setFieldByDbColumn = (fields, dbColumn, value) => {
    const field = (fields || []).find((x) => x.dbColumn === dbColumn);
    if (field) {
      field.attributeValue = value;
    }
  };

  handleIOSCompTypeChange = (value) => {
    const iosCompType = value || "Property";
    const updatedFields = JSON.parse(
      JSON.stringify(this.state.getSalesCompDetails || [])
    );
    const currentPropertyValue = this.getFieldValue(updatedFields, "BuildingName");
    const currentPropertyId = this.getFieldValue(updatedFields, "BuildingId");
    const currentLandValue = this.getFieldValue(updatedFields, "PropertyName");
    const currentLandId = this.getFieldValue(updatedFields, "LandId");

    this.setFieldValue(updatedFields, "IOSCompType", iosCompType);
    this.setFieldEditable(updatedFields, "BuildingName", iosCompType === "Property");
    this.setFieldEditable(updatedFields, "PropertyName", iosCompType === "Land");
    this.setFieldRequired(updatedFields, "BuildingName", iosCompType === "Property");
    this.setFieldRequired(updatedFields, "PropertyName", iosCompType === "Land");

    if (iosCompType === "Property") {
      this.setFieldValue(
        updatedFields,
        "BuildingName",
        this.state.tempPropertyValue != null
          ? this.state.tempPropertyValue
          : currentPropertyValue
      );
      this.setFieldValue(
        updatedFields,
        "BuildingId",
        this.state.tempPropertyId != null
          ? this.state.tempPropertyId
          : currentPropertyId
      );
      this.setFieldValue(updatedFields, "PropertyName", null);
      this.setFieldValue(updatedFields, "LandId", null);
    } else {
      this.setFieldValue(
        updatedFields,
        "PropertyName",
        this.state.tempLandValue != null
          ? this.state.tempLandValue
          : currentLandValue
      );
      this.setFieldValue(
        updatedFields,
        "LandId",
        this.state.tempLandId != null ? this.state.tempLandId : currentLandId
      );
      this.setFieldValue(updatedFields, "BuildingName", null);
      this.setFieldValue(updatedFields, "BuildingId", null);
    }

    this.setState(
      {
        iosCompType,
        tempPropertyValue: currentPropertyValue || this.state.tempPropertyValue,
        tempPropertyId: currentPropertyId || this.state.tempPropertyId,
        tempLandValue: currentLandValue || this.state.tempLandValue,
        tempLandId: currentLandId || this.state.tempLandId,
        selectedBuilding:
          iosCompType === "Property"
            ? this.state.tempPropertyValue != null
              ? this.state.tempPropertyValue
              : currentPropertyValue
            : null,
        selectedLand:
          iosCompType === "Land"
            ? this.state.tempLandValue != null
              ? this.state.tempLandValue
              : currentLandValue
            : null,
        salesCompMasterDetail: updatedFields,
        getSalesCompDetails: updatedFields,
        reloadSalesComp: !this.state.reloadSalesComp,
      },
      () => {
        this.forceUpdate();
      }
    );
  };

  getSaveReadySaleCompData = () => {
    const saleCompData = JSON.parse(
      JSON.stringify(this.state.getSalesCompDetails || [])
    );
    
    // Clear the non-active comp type fields
    if (this.state.iosCompType === "Property") {
      this.setFieldByDbColumn(saleCompData, "LandId", null);
      this.setFieldByDbColumn(saleCompData, "PropertyName", null);
    } else {
      this.setFieldByDbColumn(saleCompData, "BuildingId", null);
      this.setFieldByDbColumn(saleCompData, "BuildingName", null);
    }

    // Filter out IOSCompType field - it's only for UI, not for saving
    return saleCompData.filter(
      (x) => x.dbColumn !== "IOSSaleCompType" && x.dbColumn !== "IOSCompType"
    );
  };

  resetIOSCompTypeTempState = () => {
    this.setState({
      tempPropertyValue: null,
      tempPropertyId: null,
      tempLandValue: null,
      tempLandId: null,
    });
  };

  onSearch = (event, value, e) => {
    const { isDataSaved } = this.state;
    let compId = this.state.salesCompsSummaryData.find(
      (m) => m.buyer == value
    ).compId;
    this.setState({
      compId: compId,
      isSearchedClicked: true,
    });

    if (isDataSaved == false) {
      this.setState({ getHistory: [] });
      this.getData(compId);
    }
    if (compId) {
			this.props.history.push(`/${routes.iossalescomps}/${compId}`);
		}
  };
  
  onSearchLeaseComp = () => {
    this.setState({
      isSearchedClicked: false,
      isDataSaved: false,
    });
    this.setState({ getHistory: [] });
    this.getData(this.state.compId);
  };
  
  onClickHandel(e) {
    if (e == true) {
      this.onSearchLeaseComp();
      this.setState({
        isSearchedClicked: false,
      });
    } else {
      this.setState({
        isSearchedClicked: false,
      });
    }
  }

  onDeleteClickHandel(e) {
    if (e == true) {
      apiDelete({
        url: `${API_URL.Master.softDeleteComps}`,
        params: { compId: this.state.compId, businessLineId: 2 },
      })
        .then(({ data: response }) => {
          if (response.success === true) {
            ShowToast(
              "Sales Comp deleted successfully",
              toastType.SUCCESS,
              5000,
              500
            );
            this.setState({
              isDataSaved: false,
            });
            this.props.onBackClick();
            this.props.reloadData();
          } else {
            ShowToast(
              "Server Error! Sales Comp not deleted",
              toastType.ERROR,
              5000,
              500
            );
          }
        })
        .catch(() => {
          ShowToast(commonLabels.somethingWrong, toastType.error, 5000, 500);
        });
      this.setState({
        isDeleteClicked: false,
      });
    } else {
      this.setState({
        isDeleteClicked: false,
      });
    }
  }

  onDeleteClick = () => {
    this.setState({ isDeleteClicked: true });
  };

  handleChange = (event) => {
    setState({ lastModifiedValue: event.target.value });
  };

  getData = (compId) => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.IOSSalesComps.getIosSaleCompDetail,
        key: "getSalesCompDetails",
        params: { compId: compId },
      },
    ])
      .then((getSalesCompDetails) => {
        this._asyncRequest = null;
        if (getSalesCompDetails.getSalesCompDetails.success == true) {
          const detailFields = getSalesCompDetails.getSalesCompDetails.data || [];
          let companyName = this.getFieldValue(detailFields, "Buyer");
          let companySellerName = this.getFieldValue(detailFields, "Seller");
          let buildingName = this.getFieldValue(detailFields, "BuildingName");

          const params = {
            businessLineId: 2,
            searchText: companyName,
          };
          apiRequest({
            url: API_URL.Master.getALLBrokerFirm,
            params,
          })
            .then(({ data: brokerMasterDetails }) => {
              this.setState(
                {
                  brokerMasterDetails: camelcaseKeys(brokerMasterDetails) || [],
                  reloadCompData: !this.state.reloadCompData,
                },
                () => {
                  this.forceUpdate();
                }
              );
            })
            .catch((reason) => {
              this._asyncRequest = null;
              ShowToast(
                commonLabels.somethingWrong,
                toastType.ERROR,
                5000,
                500,
                "Server error"
              );
            });

          const params1 = {
            businessLineId: 2,
            searchText: companySellerName,
            compId: this.state.compId,
          };
          apiRequest({
            url: API_URL.Master.getALLSellerFirm,
            params: params1,
          })
            .then(({ data: getAllSellerDetails }) => {
              this.setState(
                {
                  getAllSellerDetails: camelcaseKeys(getAllSellerDetails) || [],
                },
                () => {
                  this.forceUpdate();
                }
              );
            })
            .catch((reason) => {
              this._asyncRequest = null;
              ShowToast(
                commonLabels.somethingWrong,
                toastType.ERROR,
                5000,
                500,
                "Server error"
              );
            });

          const buildingParams = {
            businessLineId: 2,
            searchText: buildingName,
            marketId: this.state.selectedMarketId
          };
          apiRequest(
            {
              url: API_URL.Master.getBuildingNameAddressCostarMaster,
              params: buildingParams
            }
          ).then(({ data: getBuildingMaster }) => {
            this.setState({
              buildingMasterDetails:
                camelcaseKeys(getBuildingMaster) || [],
              reloadCompData: !this.state.reloadCompData,
            }, () => { this.forceUpdate() });
          })
            .catch((reason) => {
              this._asyncRequest = null;
              ShowToast(commonLabels.somethingWrong, toastType.ERROR, 5000, 500, 'Server error');
            });

          const iosCompType = this.getInitialIOSCompType(detailFields);
          this.applyIOSCompTypeToFields(detailFields, iosCompType);

          this.setState({
            getSalesCompDetails:
              camelcaseKeys(getSalesCompDetails.getSalesCompDetails.data) || [],
            getHistory:
              camelcaseKeys(
                getSalesCompDetails.getSalesCompDetails.configuration
              ) || [],
            ...this.getIOSCompTypeStateFromFields(detailFields),
          });
          this.forceUpdate();
        } else {
          ShowToast(
            "Something went wrong",
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  getRequiredData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Master.getAllCompType,
        key: "getAllCompType",
        fromCache: true,
        duration: 60,
      },
    ])
      .then((getAllCompType) => {
        this._asyncRequest = null;
        if (getAllCompType.getAllCompType.success == true) {
          this.setState({
            getAllCompType:
              camelcaseKeys(getAllCompType.getAllCompType.data).filter((m) => {
                if (m.compType === 'IOS Sales') return m;
              }) || [],
            reloadCompData: !this.state.reloadCompData,
          });

          this.forceUpdate();
        } else {
          ShowToast(
            "Something went wrong",
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  getSalesCompData() {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.IOSSalesComps.iosSalesCompsSummaryData,
        key: "salesCompsSummaryData",
        params: { marketId: this.state.selectedMarketId },
      },
      {
        url: API_URL.Master.getAllMSalesStatus,
        key: "getAllMSalesStatus",
        fromCache: true,
        duration: 60,
      },
      {
        url: API_URL.Master.getAllCompType,
        key: "getAllCompType",
        fromCache: true,
        duration: 60,
      },
    ])
      .then((getSalesCompDetails) => {
        this._asyncRequest = null;
        if (getSalesCompDetails.getAllCompType.success == true) {
          this.setState({
            salesCompsSummaryData:
              camelcaseKeys(getSalesCompDetails.salesCompsSummaryData.data) ||
              [],
            getAllMSalesStatus:
              camelcaseKeys(getSalesCompDetails.getAllMSalesStatus.data) || [],
            getAllCompType:
              camelcaseKeys(getSalesCompDetails.getAllCompType.data).filter((m) => {
                if (m.compType === 'IOS Sales') return m;
              }) || [],
          });
          this.forceUpdate();
        } else {
          ShowToast(
            "Something went wrong",
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  getCraneMasterData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Master.industrialBuildingCraneData,
        key: "getCraneMaster",
      },
    ])
      .then((getCraneMaster) => {
        this._asyncRequest = null;
        if (getCraneMaster.getCraneMaster.success == true) {
          this.setState(
            {
              getCraneMaster:
                camelcaseKeys(getCraneMaster.getCraneMaster.data) || [],
              reloadCompData: !this.state.reloadCompData,
            },
            () => {
              this.forceUpdate();
            }
          );
        } else {
          ShowToast(
            "Something went wrong",
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.globalMarketId !== this.state.selectedMarketId) {
      this.setState({ selectedMarketId: nextProps.globalMarketId });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.globalMarketId !== this.props.globalMarketId) {
        this.fetchBuildingMaster(this.props.globalMarketId);
        this.getSalesCompData();
    }
  }

  fetchBuildingMaster = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Master.getBuildingNameAddressCostarMaster,
        key: "buildingMasterDetails",
        params: { businessLineId: 2, marketId: this.props.globalMarketId },
        fromCache: true,
        duration: 60,
        clearCache: true,
      },
      ])
      .then((res) => {
        if (res.buildingMasterDetails.success) {
          this.setState({
            buildingMasterDetails: camelcaseKeys(res.buildingMasterDetails.data) || [],
            reloadCompData: !this.state.reloadCompData,
          });
        }
      });
  };

  componentDidMount() {
    debugger;
    console.log(this.props.compId);
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.IOSSalesComps.getIosSaleCompDetail,
        key: "getSalesCompDetails",
        params: { compId: this.props.selectedCompId },
      },
      {
        url: API_URL.Master.getAllNegotation,
        key: "getAllNegotationType",
        params: { businessLineId: 2 },
        fromCache: true,
        duration: 60,
      },
      {
        url: API_URL.Master.GetAllInvestmentType,
        key: "getAllInvestmentType",
        params: { businessLineId: 2 },
        fromCache: true,
        duration: 60,
      },
      {
        url: API_URL.Master.GetAllDockHeight,
        key: "getAllDockHeight",
        params: { businessLineId: 2 },
        fromCache: true,
        duration: 60,
      },
      {
        url: API_URL.Master.GetAllDockConfiguration,
        key: "getAllDockConfiguration",
        params: { businessLineId: 2 },
        fromCache: true,
        duration: 60,
      },
      {
        url: API_URL.Master.getBuildingNameAddressCostarMaster,
        key: "buildingMasterDetails",
        params: { businessLineId: 2, marketId: this.state.selectedMarketId },
      },
      {
        url: API_URL.Master.getAllCompType,
        key: "getAllCompType",
        fromCache: true,
        duration: 60,
      },
      {
        url: API_URL.Master.getCompSourceAndRepresentationTypeMasters,
        key: "getCompSourceAndRepresentationTypeMasters",
        params: { businessLineId: 2 },
      },
      {
        url: API_URL.Master.GetAllIndLand,
        key: "getAllIndLand",
        params: { businessLineId: 2 },
      },
    ])
      .then((getSalesCompDetails) => {
        this._asyncRequest = null;
        if (getSalesCompDetails.getSalesCompDetails.success == true) {
          const assignedMarkets = this.props.assignedMarkets || [];
					const isInAddMode = this.props.isInAddMode;
          debugger;
					if(!isInAddMode){
						const compIdField = getSalesCompDetails.getSalesCompDetails.data.find(
							(item) => item.dbColumn === "CompId"
						);
						const marketField = getSalesCompDetails.getSalesCompDetails.data.find(
							(item) => item.dbColumn === "Market"
						);
						const compMarket = marketField && marketField.attributeValue;
            debugger;
            if (!compIdField || !compIdField.attributeValue || 
							compIdField.attributeValue === 0) {
							this.setState({ notFound: true });
							return;
						} 
            
						const hasMarketAccess = assignedMarkets.some(
							(m) => m.market == compMarket
						);
            if (!hasMarketAccess) {
							this.setState({ unAuthorized: true });
							return;
						}

						const compMarketId = assignedMarkets.find( (m) => m.market === compMarket)?.marketId || null;
            const { globalMarketId } = this.props;
						const isAllMarkets =
							typeof globalMarketId === 'string' && globalMarketId.includes('|');

						if (!isAllMarkets && compMarketId && compMarketId.toString() !== globalMarketId) {
							this.props.onMarketChange(compMarketId);
						}
					}

          const detailFields = getSalesCompDetails.getSalesCompDetails.data || [];
          let companyName = this.getFieldValue(detailFields, "Buyer");
          let companySellerName = this.getFieldValue(detailFields, "Seller");
          let buildingName = this.getFieldValue(detailFields, "BuildingName");

          let getCompType = getSalesCompDetails.getAllCompType.data.filter((m) => {
            if (m.compType === "IOS Sales") return m;
          });

          if (getCompType.length > 0) {
            this.setFieldValue(detailFields, "CompTypeId", getCompType[0].compTypeID);
            this.setFieldValue(detailFields, "CompType", getCompType[0].compType);
          }

          const params = {
            businessLineId: 2,
            searchText: companyName,
            compId: this.state.compId,
          };
          apiRequest({
            url: API_URL.Master.getALLBrokerFirm,
            params,
          })
            .then(({ data: brokerMasterDetails }) => {
              this.setState(
                {
                  brokerMasterDetails: camelcaseKeys(brokerMasterDetails) || [],
                  reloadCompData: !this.state.reloadCompData,
                },
                () => {
                  this.forceUpdate();
                }
              );
            })
            .catch((reason) => {
              this._asyncRequest = null;
              ShowToast(
                commonLabels.somethingWrong,
                toastType.ERROR,
                5000,
                500,
                "Server error"
              );
            });

          const params1 = {
            businessLineId: 2,
            searchText: companySellerName,
            compId: this.state.compId,
          };
          apiRequest({
            url: API_URL.Master.getALLSellerFirm,
            params: params1,
          })
            .then(({ data: getAllSellerDetails }) => {
              this.setState(
                {
                  getAllSellerDetails: camelcaseKeys(getAllSellerDetails) || [],
                },
                () => {
                  this.forceUpdate();
                }
              );
            })
            .catch((reason) => {
              this._asyncRequest = null;
              ShowToast(
                commonLabels.somethingWrong,
                toastType.ERROR,
                5000,
                500,
                "Server error"
              );
            });

          if (this.state.selectedBuildingDetails
            && this.state.selectedBuildingDetails.length > 0
            && this.props.isInAddMode === true) {
            var tempXid = this.getFieldValue(this.state.selectedBuildingDetails, "BuildingId");
            var tempXname = getSalesCompDetails.buildingMasterDetails.data.find(
              (x) => x.buildingId == tempXid
            )?.buildingName;

            if (tempXid && tempXname) {
              this.setFieldValue(detailFields, "BuildingId", tempXid);
              this.setFieldValue(detailFields, "BuildingName", tempXname);
            }
          }

          const iosCompType = this.getInitialIOSCompType(detailFields);
          this.applyIOSCompTypeToFields(detailFields, iosCompType);

          this.setState({
            getSalesCompDetails:
              camelcaseKeys(getSalesCompDetails.getSalesCompDetails.data) || [],
            getHistory:
              camelcaseKeys(
                getSalesCompDetails.getSalesCompDetails.configuration
              ) || [],
            getAllNegotationType: camelcaseKeys(getSalesCompDetails.getAllNegotationType.data) || [],
            getAllInvestmentType: camelcaseKeys(getSalesCompDetails.getAllInvestmentType.data) || [],
            getAllDockHeight: camelcaseKeys(getSalesCompDetails.getAllDockHeight.data) || [],
            getAllDockConfiguration: camelcaseKeys(getSalesCompDetails.getAllDockConfiguration.data) || [],
            getAllCompSource:
              camelcaseKeys(getSalesCompDetails.getCompSourceAndRepresentationTypeMasters.compSource.data) || [],
            getSalesCompDetailsResponse:
              camelcaseKeys(getSalesCompDetails.getSalesCompDetails.data) || [],
            getAllRepresentationType:
              camelcaseKeys(getSalesCompDetails.getCompSourceAndRepresentationTypeMasters.representationType.data) ||
              [],
            buildingMasterDetails:
              camelcaseKeys(getSalesCompDetails.buildingMasterDetails.data) ||
              [],
            getAllCompType:
              camelcaseKeys(getSalesCompDetails.getAllCompType.data) || [],
            getAllIndLand:
              camelcaseKeys(getSalesCompDetails.getAllIndLand.data) || [],
            reloadCompData: !this.state.reloadCompData,
            ...this.getIOSCompTypeStateFromFields(detailFields),
            notFound: false
          });
          if (this.state.getCraneMaster.length == 0) {
            this.getCraneMasterData();
          }
          this.forceUpdate();
        } else {
          ShowToast(
            "Something went wrong",
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
          this.setState({notFound: false});
        }
      })
      .catch(() => {
        this._asyncRequest = null;
        this.setState({notFound: false});
      });
    if (this.state.salesCompsSummaryData.length == 0 || this.state.getAllSellerDetails.length == 0 || this.state.getAllCompType.length == 0) {
      this.getSalesCompData();
    }
    else if (this.props.isInAddMode == true) {
      this.getRequiredData();
    }
  }

  enableEdit = () => {
    this.setState({
      isEditEnabled: true,
    });
    this.getRequiredData();
    this.forceUpdate();
  };

  getSpsData = () => {
    let env = getCurrentEnvironment().sharePointLibrary;
    if (getSPSTokenData()) {
      this.setState({ spsData: {} });
      getSpsAPiRequest(getSharePointUrl('streamrealty', 'getFolder')).then((res) => {
        const folderName = env;
        if (res.value !== null && res.value.length > 0 &&
          (res.value.find(x => x.displayName === folderName || x.name === folderName) !== undefined)) {
          const parentFolder = res.value.find(x => x.displayName === folderName || x.name === folderName);
          const driveId = parentFolder.parentReference.driveId;
          const folderKey = parentFolder.id;
          this.setState({ spListkey: folderKey });
          getSpsAPiRequest(
            getSharePointUrl(
              'streamrealty',
              'getSps',
              folderKey
            )
          ).then((spsDataRes) => {
            const subFolder = "SalesComps"
            if (spsDataRes.value !== null && spsDataRes.value.length > 0 &&
              (spsDataRes.value.find(x => x.name === subFolder || x.displayName === subFolder) !== undefined)) {
              const folder = spsDataRes.value.find(x => x.name === subFolder || x.displayName === subFolder);
              const driveId = folder.parentReference.driveId;
              const key = folder.id;
              let fileName = "";
              if (this.state.getSalesCompDetails.length > 0) {
                fileName = this.state.getSalesCompDetails.find((x) => x.dbColumn == "ImportFileName"
                )?.attributeValue;
              }
              if (fileName !== "")
                this.getList(fileName);
            }
          });
        }
      });
    }
    else {
      apiRequest({ url: API_URL.powerBi.AcquireSPToken }).then(({ data }) => {
        if (data) {
          setSPSToken(data);
          this.getSpsData();
        }
      });
    }
  }

  getCompChanges = (formFields) => {
    let buyerValue = this.getFieldValue(formFields, "Buyer");
    let buildingNameValue = this.getFieldValue(formFields, "BuildingName");
    let landNameValue = this.getFieldValue(formFields, "PropertyName");
    let buyerData = buyerValue;
    if (buyerValue == "" || buyerValue == "" || buyerValue == undefined) {
      buyerData = undefined;
    }
    let buildingData = buildingNameValue;
    if (
      buildingNameValue == "" ||
      buildingNameValue == "" ||
      buildingNameValue == undefined
    ) {
      buildingData = undefined;
    }
    let landData = landNameValue;
    if (
      landNameValue == "" ||
      landNameValue == "" ||
      landNameValue == undefined
    ) {
      landData = undefined;
    }
    this.setState(
      {
        getSalesCompDetails: formFields,
        reloadCompData: !this.state.reloadCompData,
        isDataSaved: true,
        isSearchedClicked: false,
        selectedBuildingOwner: buyerData,
        selectedBuilding: buildingData,
        selectedLand: landData,
        buyerSelected: null,
        sellerSelected: null,
        buildingNameSelected: null,
        landNameSelected: null,
      },
      () => {
        this.forceUpdate();
      }
    );
  };

  validateForm = () => {
    const formData = this.state.getSalesCompDetails;
    let isValid = true;
    let breakCondition = false;
    if (formData.length == 0) {
      const msg =
        "No change detected. Please make necessary changes and try again.";
      isValid = false;
      breakCondition = true;
      ShowToast(msg, toastType.ERROR, 5000, 500);
    }
    formData.forEach((x) => {
      if (
        x.isRequired == true &&
        (x.attributeValue != null
          ? x.attributeValue.trim() == ""
          : x.attributeValue == "" ||
          x.attributeValue == undefined ||
          x.attributeValue == null) &&
        breakCondition != true
      ) {
        const msg = "Please fill all the mandatory fields";
        isValid = false;
        breakCondition = true;
        ShowToast(msg, toastType.ERROR, 5000, 500);
      }
    });
    return isValid;
  };

  validateRequiredFields = (formElementFields, stateToBeUpdate = {}) => {
    let IsValid = true;
    formElementFields.forEach((ele) => {
      isInputValid(ele.attributeValue, ele, this.state.getSalesCompDetails);
      if (ele.isInErrorState === true) {
        IsValid = false;
      }
    });
    stateToBeUpdate = {
      ...stateToBeUpdate,
      getSalesCompDetails: formElementFields,
      reloadCompData: !this.state.reloadCompData,
    };
    this.setState(stateToBeUpdate);

    return IsValid;
  };

  saveCompDetails = () => {
    // Validate using the original form data (with IOSCompType)
    let isValid = this.validateForm();
    let isInputValid = this.validateRequiredFields(this.state.getSalesCompDetails);
    
    // Check if property/land is selected based on iosCompType by reading from form fields
    const buildingIdValue = this.getFieldValue(this.state.getSalesCompDetails, "BuildingId");
    const buildingNameValue = this.getFieldValue(this.state.getSalesCompDetails, "BuildingName");
    const landIdValue = this.getFieldValue(this.state.getSalesCompDetails, "LandId");
    const landNameValue = this.getFieldValue(this.state.getSalesCompDetails, "PropertyName");
    
    const hasPropertySelected = this.state.iosCompType === "Property" && 
      (buildingIdValue || buildingNameValue);
    const hasLandSelected = this.state.iosCompType === "Land" && 
      (landIdValue || landNameValue);
    const hasPropertyOrLand = hasPropertySelected || hasLandSelected;
    
    // Validation fails if:
    // 1. Form validation failed OR required fields validation failed
    // 2. No property or land selected based on iosCompType
    if (
      !isValid || 
      !isInputValid ||
      !hasPropertyOrLand
    ) {
      if (!isInputValid) {
        ShowToast(
          "There is validation error on page.",
          toastType.ERROR,
          5000,
          500
        );
      } else if (!hasPropertyOrLand) {
        ShowToast(
          "Please select at least one Property or Land.",
          toastType.ERROR,
          5000,
          500
        );
      }
      return false;
    } else {
      // Only get the save-ready data AFTER validation passes
      const salesCompData = this.getSaveReadySaleCompData();
      salesCompData.forEach((x) => {
        x.attributeValue =
          x.attributeValue != null
            ? x.attributeValue.toString().trim()
            : x.attributeValue;

        if (
          _.camelCase(x.dbColumn) === _.camelCase("BuildingId") ||
          _.camelCase(x.dbColumn) === _.camelCase("LandId") ||
          _.camelCase(x.dbColumn) === _.camelCase("BuyerId") ||
          _.camelCase(x.dbColumn) === _.camelCase("SellerId") ||
          _.camelCase(x.dbColumn) === _.camelCase("SalesStatusId") ||
          _.camelCase(x.dbColumn) === _.camelCase("TenantRepBrokerId") ||
          _.camelCase(x.dbColumn) === _.camelCase("RepresentationTypeId") ||
          _.camelCase(x.dbColumn) === _.camelCase("TenancyTypeId") ||
          _.camelCase(x.dbColumn) === _.camelCase("CompTypeId") ||
          _.camelCase(x.dbColumn) === _.camelCase("CompSourceId") ||
          _.camelCase(x.dbColumn) === _.camelCase("NegotiationTypeId")
        ) {
          if (x.attributeValue != null)
            x.attributeValue = x.attributeValue.toString();
        }
      });

      if (this.props.actionType === "Edit") {
        const compId = salesCompData.filter(
          (x) => _.camelCase(x.dbColumn) === _.camelCase("CompId")
        );

        apiPut(
          API_URL.IOSSalesComps.updateIosSaleCompDetail,
          salesCompData,
          {
            CompId: compId[0].attributeValue,
          }
        )
          .then(({ data: response }) => {
            if (response.success === true) {
              ShowToast(
                "Comp updated successfully",
                toastType.SUCCESS,
                5000,
                500
              );
              this.setState({
                isDataSaved: false,
              });
              this.resetIOSCompTypeTempState();
              if (this.props.isRedirectedFromProperty == true)
                this.props.onBackClick();
              else{
                this.props.onBackClick();
                this.props.reloadData();
              }
            } else {
              ShowToast(response.message, toastType.ERROR, 5000, 500);
            }
          })
          .catch(() => {
            ShowToast(commonLabels.somethingWrong, toastType.error, 5000, 500);
          });
      } else {
        apiPost({
          url: API_URL.IOSSalesComps.addIosSaleCompDetail,
          params: {},
          postBody: salesCompData,
        })
          .then(({ data: response }) => {
            if (response.success === true) {
              ShowToast(
                "Comp added successfully",
                toastType.SUCCESS,
                5000,
                500
              );
              this.resetIOSCompTypeTempState();
              if (this.props.isRedirectedFromProperty == true)
                this.props.onBackClick();
              else
                this.props.reloadData();
            } else {
              ShowToast(response.message, toastType.error, 5000, 500);
            }
          })
          .catch(() => {
            ShowToast(commonLabels.somethingWrong, toastType.error, 5000, 500);
          });
      }
    }
  };

  onBackClick = () => {
    this.props.onBackClick();
    if (this.state.isAddedFromPopup) this.props.onCancelClickAfterPopupAdd();
  };

  getHistoryDataByField = (val) => {
    const params = {
      entityPrimaryKey: this.state.getHistory[0].entityPrimaryKey,
      sectionDetailId: val.sectionDetailId,
      sectionId: val.sectionId,
      dbTable: val.dbTable,
      dbColumn: val.dbColumn,
      businessLineId: 2,
    };

    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Building.getHistoryDetailByField,
        key: "getHistoryDetailByField",
        params: params,
      },
    ])
      .then((getHistoryDetailByField) => {
        this._asyncRequest = null;
        if (getHistoryDetailByField.getHistoryDetailByField.success == true) {
          this.setState({
            getHistoryDetailByField:
              camelcaseKeys(
                getHistoryDetailByField.getHistoryDetailByField.data
              ) || [],
            openHistoryform: true,
            isHistoryByField: true,
          });
          this.forceUpdate();
        } else {
          ShowToast(
            "Something went wrong",
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  handleClose = (e, val) => {
    if (val == "blur") return;
    this.setState({ openHistoryform: true });
  };

  handleChange = (e, val) => {
    const params = {
      entityPrimaryKey: val.entityPrimaryKey,
      modifiedDate: moment(moment(val.createdDate).toDate())
        .format("MM-DD-YYYY HH:mm:ss")
        .toString(),
      sectionId: val.sectionId,
      dbTable: val.dbTable,
      businessLineId: 2,
    };
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Building.getHistoryDataByUser,
        key: "getHistoryDataByUser",
        params: params,
      },
    ])
      .then((getHistoryDataByUser) => {
        this._asyncRequest = null;
        if (getHistoryDataByUser.getHistoryDataByUser.success == true) {
          this.setState({
            getHistoryDataByUser:
              camelcaseKeys(getHistoryDataByUser.getHistoryDataByUser.data) ||
              [],
            openHistoryform: true,
          });
          this.forceUpdate();
        } else {
          ShowToast(
            "Something went wrong",
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  goToAddBuilding = (source, option, updateoption = true) => {
    this.setState({
      openaddform: true,
      addformtitle: source.AddNewOptiontitle,
      addNewformComponent: EditBuilding,
      addnewClientSource: source,
    });
  };

  onPopupBackClick = () => {
    this.setState({ detailView: false, selectedEditRowId: -1 });
    if (this.state.openaddform == true) {
      this.setState({ openaddform: false }, () => {
        this.forceUpdate();
      });
    }
  };

  reloadPropertyData = (buildingData) => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Master.getBuildingNameAddressCostarMaster,
        key: "buildingMasterDetails",
        params: { businessLineId: 2, marketId: this.state.selectedMarketId },
        fromCache: true,
        duration: 60,
        clearCache: true,
      },
    ])
      .then((buildingMasterDetails) => {
        this._asyncRequest = null;
        if (buildingMasterDetails.buildingMasterDetails.success == true) {
          this.setState(
            {
              buildingMasterDetails:
                camelcaseKeys(
                  buildingMasterDetails.buildingMasterDetails.data
                ) || [],
              openaddform: false,
              addNewformComponent: undefined,
              reloadCompData: !this.state.reloadCompData,
              isAddedFromPopup: true,
            },
            () => {
              this.forceUpdate();
            }
          );
          this.setBuilding(buildingData);
        } else {
          ShowToast(
            "Something went wrong",
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  buildingChanges = () => { };

  goToAddLand = (source, option, updateoption = true) => {
    this.setState({
      openaddform: true,
      addformtitle: source.AddNewOptiontitle,
      addNewformComponent: EditLand,
      addnewClientSource: source,
    });
  };

  reloadLandData = (landData) => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Master.GetAllIndLand,
        key: "getAllIndLand",
        params: { businessLineId: 2 },
      },
    ])
      .then((getAllIndLand) => {
        this._asyncRequest = null;
        if (getAllIndLand.getAllIndLand.success == true) {
          this.setState(
            {
              getAllIndLand: camelcaseKeys(getAllIndLand.getAllIndLand.data) || [],
              openaddform: false,
              addNewformComponent: undefined,
              reloadCompData: !this.state.reloadCompData,
              isAddedFromPopup: true,
            },
            () => {
              this.forceUpdate();
            }
          );
          if (landData) {
            this.setLand(landData);
          }
        } else {
          ShowToast(
            "Something went wrong",
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  goToAddBuildingOwner = (source, option, updateoption = true) => {
    this.setState({
      openPropertyOwnerAddForm: true,
      addformtitle: source.AddNewOptiontitle,
      addNewformComponent: EditBuildingOwner,
      addnewClientSource: source,
    });
  };

  onPropertyOwnerPopupBackClick = () => {
    this.setState({ detailView: false, selectedEditRowId: -1 });
    if (this.state.openPropertyOwnerAddForm == true) {
      this.setState({ openPropertyOwnerAddForm: false }, () => {
        this.forceUpdate();
      });
    } else {
      this.props.onBackClick();
    }
  };

  reloadPropertyOwnerData = (companyData, bit = 0) => {
    let companyName = null;
    let cId = [];
    if (companyData != undefined && companyData.length > 0) {
      companyName = this.getFieldValue(companyData, "CompanyName");
    }

    let bData = this.state.getSalesCompDetails;
    const params = {
      businessLineId: 2,
      searchText: companyName != undefined ? companyName : null,
      compId: this.state.compId,
    };

    apiRequest({
      url: API_URL.Master.getALLBrokerFirm,
      params,
    })
      .then(({ data: brokerMasterDetails }) => {
        let breakCondition = false;
        cId = brokerMasterDetails.find((x) => {
          if (x.buyer === companyName && breakCondition == false) {
            breakCondition = true;
            return x;
          }
        });
        this.setFieldValue(bData, "Buyer", companyName);
        this.setFieldValue(bData, "BuyerId", cId?.buyerId);
        this.setState(
          {
            brokerMasterDetails: camelcaseKeys(brokerMasterDetails) || [],
            getSalesCompDetails:
              bit == 1 ? this.state.getSalesCompDetails : bData,
            reloadCompData: !this.state.reloadCompData,
          },
          () => {
            this.forceUpdate();
          }
        );
        this.setBuildingOwner(companyData);
      })
      .catch((reason) => {
        this._asyncRequest = null;
        ShowToast(
          commonLabels.somethingWrong,
          toastType.ERROR,
          5000,
          500,
          "Server error"
        );
      });
  };

  buildingOwnerChanges = () => { };

  onInputChange = (value, key) => {
    if (key == 'buildingName')
      this.setState({ buildingNameSelected: value });
    else if (key == 'PropertyName')
      this.setState({ landNameSelected: value });
    else
      this.setState({ buyerSelected: value });

    if (value.length > 2) {
      if (key == 'buildingName') {
        apiRequest(
          {
            url: API_URL.Master.getBuildingNameAddressCostarMaster,
            params: {
              businessLineId: 2,
              searchText: value,
              marketId: this.state.selectedMarketId
            }
          }
        ).then(({ data: getBuildingMaster }) => {
          this.setState({
            buildingMasterDetails:
              camelcaseKeys(getBuildingMaster) || [],
            reloadCompData: !this.state.reloadCompData,
          }, () => { this.forceUpdate() });
        })
          .catch((reason) => {
            this._asyncRequest = null;
            ShowToast(commonLabels.somethingWrong, toastType.ERROR, 5000, 500, 'Server error');
          });
      }
      else if (key == 'PropertyName') {
        apiRequestNoLoadder({
          url: API_URL.Master.GetAllIndLand,
          params: { businessLineId: 2 },
        })
          .then(({ data: getAllIndLand }) => {
            this.setState(
              {
                getAllIndLand: camelcaseKeys(getAllIndLand) || [],
                reloadCompData: !this.state.reloadCompData,
              },
              () => {
                this.forceUpdate();
              }
            );
          })
          .catch(() => {
            this._asyncRequest = null;
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              "Server error"
            );
          });
      }
      else {
        const params = {
          businessLineId: 2,
          searchText: value,
          compId: this.state.compId,
        };
        apiRequestNoLoadder({
          url: API_URL.Master.getALLBrokerFirm,
          params,
        })
          .then(({ data: brokerMasterDetails }) => {
            this.setState(
              {
                brokerMasterDetails: camelcaseKeys(brokerMasterDetails) || [],
                reloadCompData: !this.state.reloadCompData,
              },
              () => {
                this.forceUpdate();
              }
            );
          })
          .catch((reason) => {
            this._asyncRequest = null;
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              "Server error"
            );
          });
      }
    }
  };

  onSellerInputChange = (value) => {
    this.setState({ sellerSelected: value });
    if (value.length > 2) {
      const params = {
        businessLineId: 2,
        searchText: value,
        compId: this.state.compId,
      };
      apiRequestNoLoadder({
        url: API_URL.Master.getALLSellerFirm,
        params,
      })
        .then(({ data: getAllSellerDetails }) => {
          this.setState(
            {
              getAllSellerDetails: camelcaseKeys(getAllSellerDetails) || [],
              reloadCompData: !this.state.reloadCompData,
            },
            () => {
              this.forceUpdate();
            }
          );
        })
        .catch((reason) => {
          this._asyncRequest = null;
          ShowToast(
            commonLabels.somethingWrong,
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        });
    }
  };

  setBuildingOwner = (value) => {
    let companyName = "";
    if (value.length > 0) {
      companyName = this.getFieldValue(value, "CompanyName");
    }
    this.state.getSalesCompDetails.filter((x) => {
      if (x.dbColumn == "Buyer") x.attributeValue = companyName;
    });
    this.setState({
      selectedBuildingOwner: companyName,
      reloadCompData: !this.state.reloadCompData,
    });
    this.forceUpdate();
  };

  setBuilding = (value) => {
    let buildingName = "";
    if (value.length > 0) {
      buildingName = this.getFieldValue(value, "BuildingName");
    }
    this.setState({
      selectedBuilding: buildingName,
      reloadCompData: !this.state.reloadCompData,
    });
    this.state.getSalesCompDetails.filter((x) => {
      if (x.dbColumn == "BuildingName") x.attributeValue = buildingName;
    });
    this.forceUpdate();
  };

  landChanges = () => { };

  setLand = (value) => {
    let propertyName = "";
    if (value.length > 0) {
      propertyName = this.getFieldValue(value, "PropertyName");
    }
    this.setState({
      selectedLand: propertyName,
      reloadCompData: !this.state.reloadCompData,
    });
    this.state.getSalesCompDetails.filter((x) => {
      if (x.dbColumn == "PropertyName") x.attributeValue = propertyName;
    });
    this.forceUpdate();
  };

  getList = (fileName) => {
    getSpsAPiRequest(
      getSharePointUrl(
        "streamrealty",
        "getInnerFolder",
        this.state.spListkey,
        "Sales"
      )
    ).then((spsDataRes) => {
      if (spsDataRes) {
        const { value } = spsDataRes;
        for (let i = 0; i < value.length; i++) {
          if (fileName === value[i].name) {
            this.setState({
              downloadURL: value[i]["@microsoft.graph.downloadUrl"],
            });
            break;
          }
        }
      }
    });
  };

  clearDates = () => {
    let soldDate = undefined;
    let compCreatedDate = undefined;
    let closeDate = undefined;

    if (this.state.getSalesCompDetailsResponse.length > 0) {
      soldDate = this.getFieldValue(this.state.getSalesCompDetailsResponse, "SoldDate");
      compCreatedDate = this.getFieldValue(this.state.getSalesCompDetailsResponse, "CompCreatedDate");
      closeDate = this.getFieldValue(this.state.getSalesCompDetailsResponse, "Closedate");
    }

    let salesData = this.state.getSalesCompDetails;
    if (this.state.getSalesCompDetails.length > 0) {
      salesData.filter((x) => {
        if (x.dbColumn == "SoldDate") {
          if (x.attributeValue != soldDate) x.attributeValue = soldDate;
        }
        if (x.dbColumn == "CompCreatedDate") {
          if (x.attributeValue != compCreatedDate)
            x.attributeValue = compCreatedDate;
        }
        if (x.dbColumn == "Closedate") {
          if (x.attributeValue != closeDate) x.attributeValue = closeDate;
        }
      });
    }

    this.setState({
      getSalesCompDetails: salesData,
      reloadCompData: !this.state.reloadCompData,
    });
  };

  render() {
    if (this.state.notFound) {
			return <Redirect to="/notfound" />;
		}
		if (this.state.unAuthorized) {
			return <Redirect to="/unAuthorizedAccess" />;
		}
    const {
      getAllTenancy,
      getAllCompSource,
      getAllNegotationType,
      isEditEnabled,
      getSalesCompDetails,
      buildingMasterDetails,
      getAllMSalesStatus,
      getAllBuyerDetails,
      getAllSellerDetails,
      brokerMasterDetails,
      getBrokerMaster,
      getAllCompType,
      salesCompsSummaryData,
      getHistory,
      getHistoryDataByUser,
      getHistoryDetailByField,
      isHistoryByField,
      companyMasterDetails,
      getAllRepresentationType,
      getAllInvestmentType,
      getAllDockHeight,
      getAllDockConfiguration,
      getAllIndLand,
      getSubMarketMaster,
      getMarketMaster,
      getCraneMaster,
    } = this.state;

    var ownerName = "";
    let getRepresentionType = getAllRepresentationType.filter((m) => {
      if (m.representationType === "Buyer" || m.representationType === "Seller")
        return m;
    });
    debugger;
    let compFilteredDataData = salesCompsSummaryData.filter((m) => {
      if (m.buyer != null) return m;
    });
    let getCompType = getAllCompType.filter((m) => {
      if (m.compType === "IOS Sales") return m;
    });
    const filterConfig = [
      {
        type: controlType.DropDown,
        minTag: 1,
        source: compFilteredDataData,
        key: "buyer",
        placeholder: "",
        title: "Buyer",
      },
    ];
    if (getSalesCompDetails.length > 0) {
      ownerName = this.getFieldValue(getSalesCompDetails, "BuildingName") || 
                  this.getFieldValue(getSalesCompDetails, "PropertyName") || "";
    }
    const addnewOption = true;

    const companySeparatorConfig = [
      {
        separatorBeforeKey: "InternalDeal",
        order: 1,
        row: 1,
        sectionColumn: 12,
        label: "Key Transaction Details",
      },
      {
        separatorBeforeKey: "craneType",
        order: 1,
        row: 1,
        sectionColumn: 12,
        label: "Additional Space Details",
      },
      {
        separatorBeforeKey: "Buyer",
        order: 1,
        row: 1,
        sectionColumn: 12,
        label: "Deal Party",
      },
      {
        separatorBeforeKey: "CapRate",
        order: 1,
        row: 1,
        sectionColumn: 12,
        label: "Additional Notes & Details",
      },
      {
        separatorBeforeKey: "CompVerified",
        order: 1,
        row: 1,
        sectionColumn: 12,
        label: "Sourcing",
      },
    ];

    const dropDownSource = [
      {
        key: "IOSCompType",
        option: "label",
        idField: "value",
        source: [
          { label: "Property", value: "Property" },
          { label: "Land", value: "Land" },
        ],
        localChanges: false,
        onChange: this.handleIOSCompTypeChange,
      },
      {
        key: "compSource",
        option: "compSource",
        idField: "compSourceId",
        source: getAllCompSource,
      },
      {
        key: "negotiationType",
        option: "negotiationType",
        idField: "negotiationTypeId",
        source: getAllNegotationType,
      },
      {
        key: "investmentType",
        option: "investmentType",
        idField: "investmentTypeId",
        source: getAllInvestmentType,
      },
      {
        key: "dockHeight",
        option: "dockHeight",
        idField: "dockHeightId",
        source: getAllDockHeight,
      },
      {
        key: "dockConfiguration",
        option: "dockConfiguration",
        idField: "dockConfigurationId",
        source: getAllDockConfiguration,
      },
      {
        key: "representationType",
        option: "representationType",
        idField: "representationTypeId",
        source: getRepresentionType,
      },
      {
        key: "buildingName",
        option: "buildingName",
        idField: "buildingId",
        source: buildingMasterDetails,
        AddNewOption: IsSectionVisible(SECTIONS.Industrial_Property, SECTIONS.Industrial_Property_Details, SECTIONS.ADD_EDIT),
        AddNewOptiontitle: "New Property",
        AddOptionType: "Button",
        onAddClick: this.goToAddBuilding,
        onChange: this.buildingChanges,
        onInputChange: this.onInputChange,
        value: this.state.selectedBuilding,
      },
      {
        key: "PropertyName",
        option: "buildingName",
        idField: "landId",
        source: getAllIndLand,
        AddNewOption: IsSectionVisible(
          SECTIONS.Industrial_Land_Entity,
          SECTIONS.Industrial_Land_Entity_Details,
          SECTIONS.ADD_EDIT
        ),
        AddNewOptiontitle: "New Land",
        AddOptionType: "Button",
        onAddClick: this.goToAddLand,
        onChange: this.landChanges,
        onInputChange: this.onInputChange,
        value: this.state.selectedLand,
      },
      {
        key: "buyer",
        option: "buyer",
        idField: "buyerId",
        source: brokerMasterDetails,
        AddNewOption: IsSectionVisible(SECTIONS.Industrial_Company, SECTIONS.Industrial_Company_Details, SECTIONS.ADD_EDIT),
        AddNewOptiontitle: "New Company",
        AddOptionType: "Button",
        onAddClick: this.goToAddBuildingOwner,
        onChange: this.buildingOwnerChanges,
        value: this.state.selectedBuildingOwner,
        onInputChange: this.onInputChange,
      },
      {
        key: "compType",
        option: "compType",
        idField: "compTypeId",
        source: getAllCompType,
      },
      {
        key: "seller",
        option: "seller",
        idField: "sellerId",
        source: getAllSellerDetails,
        onInputChange: this.onSellerInputChange,
        value: this.state.selectedSeller,
      },
      {
        key: "salesStatus",
        option: "salesStatus",
        idField: "salesStatusId",
        source: getAllMSalesStatus,
      },
      {
        key: "brokerName",
        option: "brokerName",
        idField: "tenantRepBrokerId",
        source: getBrokerMaster,
      },
      {
        key: "craneType",
        option: "craneType",
        idField: "craneTypeId",
        source: getCraneMaster,
      },
    ];

    const DetailsFormConfig = [
      {
        key: "IOSCompType",
        type: controlType.DropDown,
        multiple: false,
      },
      {
        key: "buildingName",
        type: controlType.DropDown,
        multiple: true,
      },
      {
        key: "PropertyName",
        type: controlType.DropDown,
        multiple: true,
      },
      {
        key: "buyer",
        type: controlType.Autofill,
        multiple: false,
      },
      {
        key: "seller",
        type: controlType.Autofill,
        multiple: false,
      },
      {
        key: "compType",
        type: controlType.DropDown,
        multiple: false,
      },
      {
        key: "broker",
        type: controlType.TextBox,
        multiple: false,
      },
      {
        key: "salesStatus",
        type: controlType.DropDown,
        multiple: false,
      },
      {
        key: "soldDate",
        type: controlType.DatePicker,
        multiple: false,
      },
      {
        key: "lxDte",
        type: controlType.DatePicker,
        multiple: false,
      },
      {
        key: "salesPSF",
        type: controlType.TextBox,
        multiple: false,
      },
      {
        key: "dr",
        type: controlType.Switch,
        multiple: false,
      },
      {
        key: "notes",
        type: controlType.TextArea,
        multiple: false,
      },
      { key: "importFileName", type: controlType.Link, multiple: false },
      {
        key: "representationType",
        type: controlType.DropDown,
        multiple: false,
      },
      {
        key: "tenancyType",
        type: controlType.DropDown,
        multiple: false,
      },
      {
        key: "compSource",
        type: controlType.DropDown,
        multiple: false,
      },
      {
        key: "negotiationType",
        type: controlType.DropDown,
        multiple: false,
      },
      {
        key: "investmentType",
        type: controlType.DropDown,
        multiple: false,
      },
      {
        key: "dockHeight",
        type: controlType.DropDown,
        multiple: false,
      },
      {
        key: "dockConfiguration",
        type: controlType.DropDown,
        multiple: false,
      },
      {
        key: "craneType",
        type: controlType.DropDown,
        multiple: false,
      }
    ];
    const ownerNam = ownerName != undefined ? ownerName : this.props.ViewTitle;
    return (
      <>
        {this.state.openHistoryform && (
          <Dialog open={this.state.openHistoryform} maxWidth="lg">
            <AppBar
              style={{ position: "relative", backgroundColor: "#064473" }}
            >
              <Toolbar className="custom-toolbar">
                <Typography
                  variant="subtitle1"
                  className="app-header-white"
                  style={{ marginTop: "15px", flex: "1", color: "#FFFFF" }}
                >
                  Update History
                </Typography>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => {
                    this.setState({
                      openHistoryform: false,
                      isHistoryByField: false,
                    });
                  }}
                  aria-label="close"
                  style={{ padding: "0px" }}
                >
                  <IoMdCloseCircleOutline />
                </IconButton>
              </Toolbar>
            </AppBar>
            <div>
              <ViewHistoryData
                sourceData={getHistoryDataByUser}
                getHistoryDetailByField={getHistoryDetailByField}
                dropDownSource={dropDownSource}
                isHistoryByField={isHistoryByField}
              ></ViewHistoryData>
            </div>
          </Dialog>
        )}
        {this.state.isDataSaved && this.state.isSearchedClicked && (
          <ConfirmDialog
            IsOpen={this.state.isSearchedClicked}
            Message={
              "There are unsaved changes.Do you still want to search another Company"
            }
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onClickHandel(isValid);
              } else {
                this.onClickHandel(isValid);
              }
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          ></ConfirmDialog>
        )}
        {this.state.isDeleteClicked && (
          <ConfirmDialog
            IsOpen={this.state.isDeleteClicked}
            Message={"Are you sure you want to delete this record?"}
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onDeleteClickHandel(isValid);
              } else {
                this.onDeleteClickHandel(isValid);
              }
            }}
            AgreeText="Yes"
            DisAgreeText="No"
          ></ConfirmDialog>
        )}

        {this.state.openaddform && (
          <Dialog open={this.state.openaddform} maxWidth="lg">
            <AppBar
              style={{ position: "relative", backgroundColor: "#064473" }}
            >
              <Toolbar className="custom-toolbar">
                <Typography
                  variant="subtitle1"
                  className="app-header-white"
                  style={{ marginTop: "15px", flex: "1", color: "#FFFFF" }}
                >
                  {this.state.addformtitle}
                </Typography>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => {
                    if (this.state.addNewformComponent === EditLand) {
                      this.reloadLandData();
                    } else {
                      this.reloadPropertyData();
                    }
                  }}
                  aria-label="close"
                  style={{ padding: "0px" }}
                >
                  <IoMdCloseCircleOutline />
                </IconButton>
              </Toolbar>
            </AppBar>
            <div>
              {this.state.addNewformComponent === EditLand ? (
                <EditLand
                  globalMarketId={this.props.globalMarketId}
                  selectedBuildingId={this.state.selectedEditRowId}
                  onBackClick={this.onPopupBackClick}
                  ViewTitle={this.state.ViewTitle}
                  actionType={this.state.actionType}
                  isInAddMode={true}
                  reloadData={this.reloadData}
                  getSubMarketMaster={getSubMarketMaster}
                  getMarketMaster={getMarketMaster}
                  companyMasterDetails={companyMasterDetails}
                  isRedirectedFromTenant={true}
                  onCancelClickAfterPopupAdd={this.onCancelClickAfterPopupAdd}
                  reloadPropertyData={this.reloadLandData}
                />
              ) : (
                <EditBuilding
                  globalMarketId={this.props.globalMarketId}
                  selectedBuildingId={this.state.selectedEditRowId}
                  onBackClick={this.onPopupBackClick}
                  ViewTitle={this.state.ViewTitle}
                  actionType={this.state.actionType}
                  isInAddMode={true}
                  reloadData={this.reloadData}
                  isRedirectedFromTenant={true}
                  reloadPropertyData={this.reloadPropertyData}
                  setBuilding={this.setBuilding}
                  getSubMarketMaster={getSubMarketMaster}
                  getMarketMaster={getMarketMaster}
                  companyMasterDetails={companyMasterDetails}
                  getBrokerMaster={getBrokerMaster}
                />
              )}
            </div>
          </Dialog>
        )}

        {this.state.openPropertyOwnerAddForm && (
          <Dialog open={this.state.openPropertyOwnerAddForm} maxWidth="lg">
            <AppBar
              style={{ position: "relative", backgroundColor: "#064473" }}
            >
              <Toolbar className="custom-toolbar">
                <Typography
                  variant="subtitle1"
                  className="app-header-white"
                  style={{ marginTop: "15px", flex: "1", color: "#FFFFF" }}
                >
                  {this.state.addformtitle}
                </Typography>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => {
                    this.setState({ openPropertyOwnerAddForm: false });
                  }}
                  aria-label="close"
                  style={{ padding: "0px" }}
                >
                  <IoMdCloseCircleOutline />
                </IconButton>
              </Toolbar>
            </AppBar>
            <div>
              <EditBuildingOwner
                globalMarketId={this.props.globalMarketId}
                selectedBuildingId={this.state.selectedEditRowId}
                onBackClick={this.onPropertyOwnerPopupBackClick}
                ViewTitle={this.state.ViewTitle}
                actionType={this.state.actionType}
                isInAddMode={true}
                reloadData={this.reloadData}
                isRedirectedFromTenant={true}
                reloadPropertyOwnerData={this.reloadPropertyOwnerData}
                setBuildingOwner={this.setBuildingOwner}
              />
            </div>
          </Dialog>
        )}

        {isEditEnabled || this.props.isInAddMode ? (
          <div className="row header-container">
            <div className="col-md-4 col-lg-4">
              <div className="row">
                <PageHeader
                  btnText={"IOS Sales Comps"}
                  onBackClick={this.onBackClick}
                  title={
                    this.props.isInAddMode
                      ? "/ " + this.props.ViewTitle
                      : "/ " + ownerNam
                  }
                  style={{ color: "#00B0B9" }}
                ></PageHeader>
              </div>
            </div>

            <div className="col-md-4 col-lg-4">
              {salesCompsSummaryData.length > 0 && (
                <AutoSearch
                  placeholder="Search another Property"
                  isEditEnabled={this.state.isEditEnabled}
                  sourceData={compFilteredDataData}
                  filterConfig={filterConfig}
                  onSearch={this.onSearch}
                ></AutoSearch>
              )}
            </div>
            <div className="col-md-4 col-lg-4 end-sm">
              <Button
                size="small"
                style={{ marginTop: "5px" }}
                className={
                  this.props.isInAddMode ? "btn-clear" : "btn-clear btn-small"
                }
                onClick={() => {
                  this.setState({
                    getSalesCompDetails: JSON.parse(
                      JSON.stringify([...this.state.getSalesCompDetailsResponse])
                    ),
                    reloadCompData: !this.state.reloadCompData,
                  });
                }}
              >
                <span className="tool-icon-text">
                  {this.props.isInAddMode == true ? "Clear All" : "Undo"}
                </span>
              </Button>
              {IsSectionVisible(
                SECTIONS.IOS_Sale_Comps,
                SECTIONS.IOS_Sale_Comp_Details,
                SECTIONS.ADD_EDIT
              ) &&
                !this.props.isInAddMode && (
                  <Button
                    size="small"
                    className="notop-action-button btn-small"
                    onClick={() => {
                      this.onDeleteClick();
                    }}
                    style={{ backgroundColor: "red !important" }}
                  >
                    <span className="tool-icon-text">Delete</span>
                  </Button>
                )}
              <Button
                size="small"
                className={
                  this.props.isInAddMode
                    ? "notop-action-button"
                    : "notop-action-button btn-small"
                }
                onClick={this.onBackClick}
              >
                <span className="tool-icon-text">Cancel</span>
              </Button>
              {IsSectionVisible(
                SECTIONS.IOS_Sale_Comps,
                SECTIONS.IOS_Sale_Comp_Details,
                SECTIONS.ADD_EDIT
              ) && (
                  <Button
                    size="small"
                    className={
                      this.props.isInAddMode
                        ? "notop-action-button"
                        : "notop-action-button btn-small"
                    }
                    onClick={() => {
                      this.saveCompDetails();
                    }}
                  >
                    <span className="tool-icon-text">Save</span>
                  </Button>
                )}
            </div>
          </div>
        ) : (
          <div className="row header-container">
            <div className="col-md-4 col-lg-4">
              <PageHeader
                btnText={"IOS Sales Comps"}
                onBackClick={this.onBackClick}
                title={"/ " + ownerNam}
                style={{ color: "#00B0B9" }}
              ></PageHeader>
            </div>
            <div className="col-md-4 col-lg-4">
              {salesCompsSummaryData.length > 0 && (
                <AutoSearch
                  placeholder="Search another sales comp"
                  isEditEnabled={this.state.isEditEnabled}
                  sourceData={compFilteredDataData}
                  filterConfig={filterConfig}
                  onSearch={this.onSearch}
                ></AutoSearch>
              )}
            </div>
            <div className="col-md-4 col-lg-4 end-sm">
              {IsSectionVisible(
                SECTIONS.IOS_Sale_Comps,
                SECTIONS.IOS_Sale_Comp_Details,
                SECTIONS.ADD_EDIT
              ) && (
                  <Button
                    size="small"
                    className="notop-action-button btn-small"
                    onClick={() => {
                      this.onDeleteClick();
                    }}
                    style={{ backgroundColor: "red !important" }}
                  >
                    <span className="tool-icon-text">Delete</span>
                  </Button>
                )}
              <Button
                size="small"
                className="notop-action-button btn-small"
                onClick={this.onBackClick}
              >
                <span className="tool-icon-text">Cancel</span>
              </Button>
              {IsSectionVisible(
                SECTIONS.IOS_Sale_Comps,
                SECTIONS.IOS_Sale_Comp_Details,
                SECTIONS.ADD_EDIT
              ) && (
                  <Button
                    size="small"
                    className="notop-action-button btn-small"
                    onClick={() => {
                      this.enableEdit();
                    }}
                  >
                    <span className="tool-icon-text">Edit</span>
                  </Button>
                )}
            </div>
          </div>
        )}
        {getHistory.length > 0 && isEditEnabled && (
          <div className="row header-container">
            <div className="col-md-7 col-lg-7"></div>
            <div
              className="col-md-2 col-lg-2 end-sm"
              style={{ padding: "15px" }}
            >
              <span>Last Modified:</span>
            </div>
            <div className="col-md-3 col-lg-3 end-sm">
              <Autocomplete
                key={`lastModified:${getHistory[0].createdBy}`}
                size="small"
                underlineStyle={{ display: "none" }}
                defaultValue={{
                  createdBy: getHistory[0].createdBy,
                  createdDate: moment(getHistory[0].createdDate).format(
                    "MM-DD-YYYY HH:mm"
                  ),
                }}
                onClose={(e, val) => this.handleClose(e, val)}
                onChange={(e, val) => this.handleChange(e, val)}
                id="tags-standard"
                options={getHistory}
                getOptionLabel={(option) =>
                  option.createdBy +
                  "," +
                  moment(option.createdDate).format("MM-DD-YYYY HH:mm:ss")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    margin="normal"
                    hiddenLabel
                  />
                )}
              />
            </div>
          </div>
        )}

        <div>
          {getSalesCompDetails && (
            <FormGenerator
              gridColumn={4}
              ReloadForm={this.state.reloadCompData}
              formFields={UpdateFieldsWithConfiguration(
                getSalesCompDetails,
                DetailsFormConfig
              )}
              Editable={this.state.isEditEnabled}
              dropDownSource={dropDownSource}
              saveChanges={this.getCompChanges}
              partialForm={true}
              validationMessages={[]}
              formType={"Section"}
              separatorConfig={companySeparatorConfig}
              sectionRowConfig={[{ row: 1, column: 12 }]}
              getHistoryDataByField={this.getHistoryDataByField}
              viewPDF={[]}
            ></FormGenerator>
          )}
        </div>
      </>
    );
  }
}

export default withRouter(EditIOSSalesComp);
